import { provide, inject, reactive } from "vue";

const rowData = Symbol("rowData");

export function loadJsonData() {
  //學段  初資料
  const edusData = reactive({
    eduLevels: [],
  });

  //科目 初資料
  const subjectsData = reactive({
    subjects: [],
  });

  //依照學段 相對應的科目
  const subjectsByLevels = (selectedLevel) => {
    if (selectedLevel == "全部階段") {
      selectedLevel = "";
    }

    return subjectsData.subjects[selectedLevel];
  };

  //地區  初資料
  const areasData = reactive({
    areas: [],
  });

  const sdgsData = reactive({
    sdgs: [],
  });

  fetch("/educationLevels.json")
    .then((res) => res.json())
    .then((data) => {
      edusData.eduLevels = data;
    });

  fetch("/subjects.json")
    .then((res) => res.json())
    .then((data) => {
      subjectsData.subjects = data;
    });

  fetch("/sdg.json")
    .then((res) => res.json())
    .then((data) => {
      sdgsData.sdgs = data;
    });

  fetch("/counties.json")
    .then((res) => res.json())
    .then((data) => {
      areasData.areas = data;
    });

  provide(rowData, {
    edusData,
    subjectsData,
    sdgsData,
    areasData,
    subjectsByLevels,
  });
}

export function useJsonData() {
  const context = inject(rowData);

  if (!context) {
    throw new Error("not provided yet, not registered");
  }

  return context;
}
